import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SearchResult} from '../../../_models/_Index';
import {SaveMessage} from '../../../_helpers/save-message';
import {AccountOrganizzazione} from "../../../_models/AccountOrganizzazione";

@Component({
  selector: 'app-select-organizzazione',
  templateUrl: './select-organizzazione.component.html',
  styleUrls: ['./select-organizzazione.component.scss'],
  standalone: false
})
export class SelectOrganizzazioneComponent implements OnInit {
  @Input() organizzazioneId: number;
  @Output() organizzazioneIdChange = new EventEmitter<number>();
  organizzazioni: AccountOrganizzazione[] = [];
  loading = false;

  constructor(
    private organizzazioniService: OrganizzazioniService,
    private saveMessage: SaveMessage) { }

  ngOnInit() {
    this.getOrganizzazioni();
  }

  getOrganizzazioni = () => {
    this.loading = true;
    this.organizzazioniService
      .getOrganizzazioniFilteredAsync('', 0, 0, 'OrgName', true)
      .then((_organizzazioni: SearchResult<AccountOrganizzazione>) => this.organizzazioni = _organizzazioni.result
        .sort((a, b) => a.orgName.localeCompare(b.orgName)))
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento delle organizzazioni."))
      .finally(() => this.loading = false);
  };

  selectOrganizzazione = (e: SelectCustomEvent) => this.organizzazioneIdChange.emit(e.target.value);

  blurActiveElement() {
    const active = document.activeElement as HTMLElement | null;
    const nestedActive = active?.shadowRoot?.activeElement as HTMLElement | null;

    nestedActive?.blur();
    active?.blur();
  }
}
